import { makeAutoObservable } from "mobx";
import TaskPackagePreBaseline from "./TaskPackagePreBaseline";

export default class PreBaseline {
  constructor(
    baselineNumber,
    dateEffective,
    preBaselinePeriod,
    baselineDescription,
    projectId,
    isArchive,
    unqPreBaslineId,
    rootTaskPackage
  ) {
    this.baselineNumber = baselineNumber;
    this.dateEffective = dateEffective;
    this.preBaselinePeriod = preBaselinePeriod;
    this.baselineDescription = baselineDescription;
    this.projectId = projectId;
    this.isArchive = isArchive;
    this.unqPreBaslineId = unqPreBaslineId;
    this.rootTaskPackage = rootTaskPackage === null ? {} : rootTaskPackage;

    makeAutoObservable(this);
  }

  toJS() {
    return {
      baselineNumber: this.baselineNumber,
      dateEffective: this.dateEffective,
      preBaselinePeriod: this.preBaselinePeriod,
      baselineDescription: this.baselineDescription,
      projectId: this.projectId,
      isArchive: this.isArchive,
      unqPreBaslineId: this.unqPreBaslineId,
      rootTaskPackage:
        this.rootTaskPackage.toJS != null ? this.rootTaskPackage.toJS() : null,
    };
  }

  static fromJS(savedState) {
    const preBaselines = new PreBaseline();
    if (savedState != null) {
      preBaselines.baselineNumber = savedState.baselineNumber;
      preBaselines.dateEffective = savedState.dateEffective;
      preBaselines.preBaselinePeriod = savedState.preBaselinePeriod;
      preBaselines.baselineDescription = savedState.baselineDescription;
      preBaselines.projectId = savedState.projectId;
      preBaselines.isArchive = savedState.isArchive;
      preBaselines.unqPreBaslineId = savedState.unqPreBaslineId;
      preBaselines.rootTaskPackage = TaskPackagePreBaseline.fromJS(
        preBaselines,
        savedState.rootTaskPackage,
        ""
      );
    }
    return preBaselines;
  }
}

